import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import api, { formatApiErrorDetail } from "../lib/api";
import { BridgeMark } from "../components/BridgeMotif";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch { /* neutral — never reveal */ }
    finally { setSent(true); setBusy(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16">
      <BridgeMark size={40} />
      <h1 className="mt-4 font-display text-2xl font-bold tracking-tight text-slateink">{t("forgot.title")}</h1>
      {sent ? (
        <div className="mt-8 w-full rounded-2xl border border-border bg-white p-7 text-center" data-testid="forgot-confirmation">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#EBF6F0] text-[#1E6B47]"><CheckCircle2 className="h-6 w-6" /></div>
          <p className="mt-4 text-sm leading-relaxed text-slateink/80">{t("forgot.confirmation")}</p>
          <Button asChild variant="outline" className="mt-6 rounded-full" data-testid="forgot-back-login"><Link to="/login">{t("auth.login_here")}</Link></Button>
        </div>
      ) : (
        <>
          <p className="mt-2 text-center text-sm text-muted-foreground">{t("forgot.subtitle")}</p>
          <form onSubmit={submit} className="mt-6 w-full space-y-4 rounded-2xl border border-border bg-white p-7" data-testid="forgot-form">
            <div>
              <Label>{t("common.email")}</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-full bg-terracotta hover:bg-terracotta-hover" data-testid="forgot-submit">
              {busy ? t("common.saving") : t("forgot.submit")}
            </Button>
          </form>
          <p className="mt-6 text-sm text-muted-foreground"><Link to="/login" className="font-medium text-terracotta hover:underline">{t("auth.login_here")}</Link></p>
        </>
      )}
    </div>
  );
}
